import React from "react";
import "./QuestionCommand.scss";
import A from "../elements/A";
import { withDefaults } from "../../utils/withDefaults";

export interface QuestionCommandProps {
  question?: string;
  command?: string;
  route?: string;
  target?: string;
}

export default function QuestionCommand(incomingProps: QuestionCommandProps) {
  const props = withDefaults(incomingProps, questionCommandDefaultProps);

  if (props.question === "" || props.command === "") {
    return null;
  }
  return (
    <p className="question-command">
      {props.question}{" "}
      <A href={props.route} target={props.target}>
        {props.command}
      </A>
    </p>
  );
}

const questionCommandDefaultProps = {
  question: "",
  command: "",
  route: "/signup",
  target: "_self"
};
